import { render } from "./SiteGallery.vue?vue&type=template&id=1f8a9e98"
import script from "./SiteGallery.vue?vue&type=script&lang=js"
export * from "./SiteGallery.vue?vue&type=script&lang=js"

import "./SiteGallery.vue?vue&type=style&index=0&id=1f8a9e98&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__